var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import OnixCodetablesForm from "./OnixCodetablesForm";
import { navigation } from "../../components/navigation";
import { fetchOnixCodetableSummary, updateOnixCodetable, } from "../../api/onixService";
var OnixCodetablesEdit = function () {
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var kyRef = useRef(ky);
    useEffect(function () {
        kyRef.current = ky;
    }, [ky]);
    var _a = useState(null), initialValues = _a[0], setInitialValues = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        var alive = true;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var rec, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, fetchOnixCodetableSummary(kyRef.current, id)];
                    case 1:
                        rec = _b.sent();
                        if (alive)
                            setInitialValues(rec);
                        return [3 /*break*/, 4];
                    case 2:
                        _a = _b.sent();
                        if (alive)
                            setInitialValues(null);
                        return [3 /*break*/, 4];
                    case 3:
                        if (alive)
                            setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            alive = false;
        };
    }, [id]);
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        id: data.id,
                        number: data.number,
                        name: data.name,
                        version: data.version,
                    };
                    return [4 /*yield*/, updateOnixCodetable(kyRef.current, id, payload)];
                case 1:
                    _a.sent();
                    history.push(navigation.onixCodetables.path);
                    return [2 /*return*/];
            }
        });
    }); };
    if (loading || !initialValues)
        return null;
    return (React.createElement(OnixCodetablesForm, { initialValues: initialValues, onSubmit: handleSubmit, title: formatMessage({
            id: "ui-br-agency.onix-codetables.edit.pane.title",
        }), onCancel: function () { return history.push(navigation.onixCodetables.path); } }));
};
export default OnixCodetablesEdit;
